import { ExpandMoreIcon } from '@dhl-ui/icons'
import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiSelect = ({ palette, misc }: Pick<Tokens, 'palette' | 'misc'>) =>
  ({
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreIcon,
      },
      styleOverrides: {
        root: {
          '& .MuiSelect-select': {
            backgroundColor: palette.components.input.background,
            padding: spacing(2.5, 3, 1, 2),
            borderRadius: misc.borderRadius(),
          },
          '&.MuiInputBase-sizeSmall .MuiSelect-select': {
            padding: spacing(1.25, 3, 1.25, 2),
          },
          '&.MuiInputBase-sizeLarge .MuiSelect-select': {
            padding: spacing(2.75, 3, 1.75, 2),
          },

          '& .MuiSelect-icon:not(.Mui-disabled)': {
            color: palette.pure.dark,
            fontSize: spacing(3),
            right: spacing(2),
          },

          // disabled
          '& .MuiSelect-select.Mui-disabled': {
            backgroundColor: palette.action.disabledBackground,
            color: palette.action.disabled,
          },
          // readonly:
          '&.Mui-readOnly > .MuiSelect-icon:not(.Mui-disabled)': {
            color: palette.text.tertiary,
          },

          variants: [
            {
              props: { size: 'small' },
              style: { height: spacing(5), maxHeight: spacing(5) },
            },
            {
              props: { size: 'medium' },
              style: { height: spacing(6), maxHeight: spacing(6) },
            },
            {
              props: { size: 'large' },
              style: { height: spacing(7), maxHeight: spacing(7) },
            },
          ],
        },
        select: {
          '&:focus': {
            // TODO: what will we do in style
          },
        },
        outlined: {
          minHeight: 'unset',
          height: spacing(2.5),
          maxHeight: spacing(2.75),
          lineHeight: spacing(2.75),
        },
      },
    },
  }) satisfies ComponentCreation
